import { OptionBadgeGroup } from '../components/OptionBadgeGroup';
import { FEATURES_OPTIONS } from '../constants';
import type { StepProps } from '../types';
import { useTranslation } from 'react-i18next';

export function StepFeatures({ answers, setAnswer }: StepProps) {
  const { t } = useTranslation('onboarding');
  const featuresOptions = FEATURES_OPTIONS.map((option) => ({
    ...option,
    label: t(`features.${option.id}`),
  }));
  return (
    <OptionBadgeGroup
      options={featuresOptions}
      selected={answers.features}
      onChange={(val) => setAnswer('features', val)}
    />
  );
}
